import { useState } from 'react';

export const useOrderFlow = () => {
  const [step, setStep] = useState('country'); // country, products, cart, customer, summary
  const [orderPath, setOrderPath] = useState('immediate');
  const [showOrderTypeSelector, setShowOrderTypeSelector] = useState(false);

  const goToNextStep = () => {
    const steps = ['country', 'products', 'cart', 'customer', 'summary'];
    const currentIndex = steps.indexOf(step);
    if (currentIndex < steps.length - 1) {
      setStep(steps[currentIndex + 1]);
    }
  };

  const goToPreviousStep = () => {
    const steps = ['country', 'products', 'cart', 'customer', 'summary'];
    const currentIndex = steps.indexOf(step);
    if (currentIndex > 0) {
      setStep(steps[currentIndex - 1]);
    }
  };

  const goToStep = (targetStep) => {
    setStep(targetStep);
  };

  return {
    step,
    orderPath,
    showOrderTypeSelector,
    setStep,
    setOrderPath,
    setShowOrderTypeSelector,
    goToNextStep,
    goToPreviousStep,
    goToStep
  };
};
